import React from 'react';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Icon from '../Icon';

export default () => (
  <>
    <Heading level={2}>Rank Icons</Heading>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-1" />
        <Spacer size={6} />
        <Code>{'icon-rank-1'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="rank-2" />
        <Spacer size={6} />
        <Code>{'icon-rank-2'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-3" />
        <Spacer size={6} />
        <Code>{'icon-rank-3'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="rank-4" />
        <Spacer size={6} />
        <Code>{'icon-rank-4'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-5" />
        <Spacer size={6} />
        <Code>{'icon-rank-5'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="rank-6" />
        <Spacer size={6} />
        <Code>{'icon-rank-6'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-7" />
        <Spacer size={6} />
        <Code>{'icon-rank-7'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="rank-8" />
        <Spacer size={6} />
        <Code>{'icon-rank-8'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-9" />
        <Spacer size={6} />
        <Code>{'icon-rank-9'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="rank-10" />
        <Spacer size={6} />
        <Code>{'icon-rank-10'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-11" />
        <Spacer size={6} />
        <Code>{'icon-rank-11'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="rank-12" />
        <Spacer size={6} />
        <Code>{'icon-rank-12'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-13" />
        <Spacer size={6} />
        <Code>{'icon-rank-13'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="rank-14" />
        <Spacer size={6} />
        <Code>{'icon-rank-14'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rank-15" />
        <Spacer size={6} />
        <Code>{'icon-rank-15'}</Code>
      </FlexView>
      <FlexView align="center" />
    </FlexView>
  </>
);
